import { getRelatedProductsMap, sameSettings } from "../../../ModularFunctions";
import {
  createBG,
  createButton,
  createButton_v2,
  createCta,
  createHorizontalBorder,
  createImage,
  createImageElementsFromContainer,
  // processNumber,
  createText,
  createTextElementsFromContainer,
  // getBorderProps,
  // getRoundedRadius,
  getBgProps,
  getRelativeElementPosition,
  pxToPt
} from "../util";
import scripts from "./scripts";

const PRIMARY_FILTER = "printer-model";
const OPTIONS_FILTER = "additional-options";

const getContentElements = (mod, configs) => {
  const { containing_element, localizeNumber } = configs;
  const { html_id, content = {} } = mod;
  const {
    product_groups = [],
    settings,
    dimension_unit,
    weight_unit
  } = content;

  const content_prefix = "";
  const dummy_container = containing_element.querySelector(
    ".selected-model-container.dummy"
  );
  let elements = [];
  // Export icon
  const parent_sheet = containing_element.closest(".sheet");
  const export_el = parent_sheet.querySelector(".export-sheet-btn");
  let export_button = createButton_v2(export_el, configs, {
    name: "export-btn",
    action: {
      mouseClick: `cfgTool_export('${html_id}');`
    }
  });
  export_button.alwaysVisible = true;
  export_button.page = configs.page.idx;
  elements.push(export_button);
  // "Enabled" BG (solid white)
  const computed_bg_style = window.getComputedStyle(dummy_container);
  const bg_rect = dummy_container.getBoundingClientRect();
  const relative_bg_pos = getRelativeElementPosition(bg_rect, configs.page);
  const bg = {
    name: "bg",
    page: configs.page.idx,
    position: relative_bg_pos,
    ...getBgProps(computed_bg_style, true),
    backgroundColor: "#ffffff"
  };
  elements.push(bg);
  // "Your Configuration<sup>1</sup>"
  const your_config_el = dummy_container.querySelector(".your_config");
  const your_config = createText(
    your_config_el,
    configs,
    `${content_prefix}your_config`
  );
  elements.push(your_config);
  // Icons for width, height, depth & weight
  const attribute_images = createImageElementsFromContainer(
    dummy_container,
    configs,
    "config-tool",
    "attribute-icons"
  );
  elements = elements.concat(attribute_images);
  // "Email This Config" CTA
  const cta = dummy_container.querySelector(".cta.primary");
  const cta_options = {
    ignoreText: true
  };
  const email_cta = createCta(cta, configs, "email-cta", null, cta_options);
  elements.push(email_cta);
  // Images (currently just the icon for "Email This Config")
  const images = createImageElementsFromContainer(
    cta,
    configs,
    "config-tool",
    "email-icon"
  );
  elements = elements.concat(images);
  const email_cta_button = createButton_v2(cta, configs, {
    name: "email-btn",
    action: {
      mouseClick: `cfgTool_emailConfig('${html_id}');`
    }
  });
  elements.push(email_cta_button);
  // Overline
  const overline = dummy_container.querySelector(".overline");
  if (overline) {
    const new_el = createText(overline, configs, `${content_prefix}overline`);
    elements.push(new_el);
  }
  // Title
  const title = dummy_container.querySelector(".title");
  if (title) {
    const products_sorted = product_groups[0]?.products_in_group || [];
    products_sorted.forEach((product) => {
      const { model, id } = product;
      const layer_name = `title-${id}`;
      const new_el = createText(title, configs, layer_name, { content: model });
      elements.push(new_el);
    });
  }
  const table_headers = [
    ...dummy_container.querySelectorAll("table tbody th span")
  ];
  table_headers.forEach((th, th_idx) => {
    const new_el = createText(th, configs, `${content_prefix}th-${th_idx}`);
    elements.push(new_el);
  });
  const table_values = [
    ...dummy_container.querySelectorAll("table tbody td span")
  ];
  table_values.forEach((td, td_idx) => {
    const new_el = createText(td, configs, `${content_prefix}td-${td_idx}`);
    elements.push(new_el);
  });
  // "Email this Config" and "Part Numbers"
  const text_elements = createTextElementsFromContainer(
    dummy_container,
    "content",
    configs
  );
  elements = elements.concat(text_elements);
  // Table backgrounds
  const table_rows = [...dummy_container.querySelectorAll("table tr")];
  table_rows.forEach((row, row_idx) => {
    let row_elements = [];
    const bg = createBG(row, configs, "bg");
    if (bg) row_elements.push(bg);
    // Acquire top border only for first row
    if (row_idx === 0) {
      const border_top = createHorizontalBorder(
        row,
        configs,
        "borderTop",
        "border-top"
      );
      if (border_top) {
        row_elements.push(border_top);
      }
    }
    const border_bottom = createHorizontalBorder(
      row,
      configs,
      "borderBottom",
      "border-bottom"
    );
    if (border_bottom) row_elements.push(border_bottom);
    if (row_elements.length > 0) {
      let row_info = {
        name: `row-${row_idx}`,
        position: getRelativeElementPosition(row, configs.page),
        // Contain all content of a hotspot within the same element (and PDF layer)
        elements: row_elements
      };
      elements.push(row_info);
    }
  });
  // Config images
  const images_ph = dummy_container.querySelector("figure img");
  const images_ph_parent = images_ph.parentElement;
  const images_ph_parent_rect = images_ph_parent.getBoundingClientRect();
  const relative_images_ph_parent_pos = getRelativeElementPosition(
    images_ph_parent_rect,
    configs.page
  );
  const val_containers = {
    width: dummy_container.querySelector(".width .value"),
    height: dummy_container.querySelector(".height .value"),
    depth: dummy_container.querySelector(".depth .value"),
    weight: dummy_container.querySelector(".weight .value")
  };

  const units = {
    width: dimension_unit,
    height: dimension_unit,
    depth: dimension_unit,
    weight: weight_unit
  };
  const val_keys = Object.keys(val_containers);
  settings.forEach((setting, idx) => {
    const { image } = setting;
    const default_setting = settings.find(({ formula }) =>
      sameSettings(formula, {
        [PRIMARY_FILTER]: setting.formula[PRIMARY_FILTER]
      })
    );
    const overrides = {
      container: images_ph,
      img_src: image?.url || default_setting?.image?.url
    };
    const img = createImage(configs, image, "image", overrides);
    // Values for width, height, depth & weight
    const text_elements = val_keys.map((key) => {
      let text_obj = createText(val_containers[key], configs, key);
      // e.g. "width_value", "height_value", ...
      const value = localizeNumber(setting[`${key}_value`] || "");
      const unit = units[key] || "";
      const value_with_unit = `${value} ${unit}`.trim();
      text_obj.text.content = value_with_unit;
      //positioning adjustments so object content is not clipped
      text_obj.position.width = pxToPt(150);
      text_obj.position.x -= 33;
      return text_obj;
    });
    elements.push({
      name: `image-${idx}`,
      position: relative_images_ph_parent_pos,
      elements: [img, ...text_elements]
    });
  });
  // //checkboxes, select elements, and labels for additional options
  // const checks = [...document.querySelectorAll(".dynamic-opt-checkbox-cfg")];
  // const selects = [...document.querySelectorAll(".dynamic-opt-select-cfg")];
  // const labels = [...document.querySelectorAll(".dynamic-opt-label-cfg")];
  // const optKeys = Object.keys(
  //   getScriptVariables(mod, configs).opt_products
  // ).sort();
  // const keyDivider = optKeys.length / 3;
  // const checkKeys = optKeys.slice(0, keyDivider);
  // const labelKeys = optKeys.slice(keyDivider, keyDivider * 2);
  // const selectKeys = optKeys.slice(keyDivider * 2);

  // checks.forEach((e, i) => {
  //   const el = createCheckbox(e, configs, {
  //     name: checkKeys[i].split("_").slice(2).join("_"),
  //     page: configs.page.idx
  //   });
  //   elements.push(el);
  // });

  // labels.forEach((e, i) => {
  //   const el = createText(e, configs);
  //   el.name = labelKeys[i].split("_").slice(2).join("_");
  //   el.position = { x: 351, y: 594 - 28 * i, width: 219, height: 19.625 };
  //   el.form = { type: "text", editable: false };
  //   el.text.lineHeight = 1;
  //   el.text.size = 10;
  //   elements.push(el);
  // });

  // selects.forEach((e, i) => {
  //   const el = createFormField(e, configs, {
  //     name: selectKeys[i].split("_").slice(2).join("_"),
  //     page: configs.page.idx
  //   });
  //   el.position = { x: 304.5, y: 591 - 28 * i, width: 20, height: 15 };
  //   //remove background element since they are not dynamic
  //   delete el.elements;
  //   elements.push(el);
  // });

  return elements;
};
const getVisibilityElements = (mod, configs) => {
  const { containing_element } = configs;
  const elements = [];
  // Hide "Export" button (along with icon and divider) with a layer
  const parent_sheet = containing_element.closest(".sheet");
  const export_el = parent_sheet.querySelector(".export-sheet-btn");
  const export_el_rect = export_el.getBoundingClientRect();
  let export_button = createButton(export_el, configs, "export-btn-visibility");
  export_button.alwaysVisible = true;
  export_button.page = configs.page.idx;
  // Layer to hide the export icon + divider (or rather, right before the "Top" icon)
  const export_divider_el = export_el.nextSibling;
  const export_divider_rect = export_divider_el.getBoundingClientRect();
  let export_button_hider = JSON.parse(JSON.stringify(export_button));
  export_button_hider.backgroundColor = "#ffffff";
  // Offset to support covering the rest of the button for longer strings
  const arbitrary_left_offset_percent = 0.1;
  const tentative_new_width = export_divider_rect.x - export_el_rect.x;
  const new_width_offset = tentative_new_width * arbitrary_left_offset_percent;
  const new_width = tentative_new_width + new_width_offset;
  export_button_hider.position.x -= pxToPt(new_width_offset);
  export_button_hider.position.width = pxToPt(new_width);
  elements.push(export_button_hider);
  return elements;
};
const getElements = (mod, configs) => {
  const content = getContentElements(mod, configs);
  const visibility = getVisibilityElements(mod, configs);
  return [
    {
      name: "content",
      hidden: true,
      elements: content
    },
    {
      name: "helper",
      elements: visibility
    }
  ];
};
function getScriptVariables(mod, configs) {
  const { containing_element } = configs;
  // Disregard background image and hotspot icons since those are for EvoPDF
  const { content = {} } = mod;
  const { product_groups = [], settings } = content;
  const products_sorted = product_groups
    // Extract just the products into a single list
    .flatMap(({ products_in_group: products = [] }) => {
      const products_with_relations = products.flatMap((product) => {
        const { related_products = [] } = product;
        return [product, ...related_products];
      });
      return products_with_relations;
    });
  // Also include related models
  const product_names_sorted = products_sorted.map(({ name }) => name);
  // Create a map from product ids to info
  // This way we have something like { 1: {name: 'Epson WF-C20600', id: 1, sku: 'C11CH86201', ... }
  const product_ids_map = products_sorted
    // Extract name and ID of each product, and put into map
    .reduce(
      (acc, { id, name, label, sku, model = "" }) => ({
        ...acc,
        [id]: {
          name: name || label,
          id,
          sku,
          model
          // model: `${model} ${variant}`.trim()
        }
      }),
      {}
    );

  // From base product to related model
  const related_products_map = products_sorted.reduce(
    (acc, { id, related_products = [] }) => {
      if (related_products.length === 0) return acc;
      return {
        ...acc,
        [id]: related_products.map(({ id }) => id)
      };
    },
    {}
  );

  const related_products_props_map = () => {
    const obj = {};
    Object.keys(related_products_map).forEach((k) => {
      const foundProduct = products_sorted.find(
        ({ id }) => Number.parseInt(id) === Number.parseInt(k)
      );
      const relatedModels = foundProduct?.related_products;
      const o = {};
      (relatedModels || []).forEach(
        ({
          id,
          limit_per_unit: l,
          all_conditions_must_be_met: a,
          impacts_dimensions: i,
          product_related_product_rules: p
        }) => {
          o[id] = {};
          if (i) o[id].impactDimensions = i;
          if (l >= 0) o[id].limit = l;
          if (p?.length > 0) o[id].rulesObj = { meetAll: a, rules: p };
        }
      );
      obj[k] = o;
    });
    return obj;
  };

  products_sorted.reduce((acc, { related_products = [] }) => {
    if (related_products.length === 0) return acc;
    return {
      ...acc,
      id: related_products.map(({ id }) => id),
      limit: related_products.map(({ limit_per_unit: l }) => l)
    };
  }, {});
  // With the above map from product names to IDs, we can relay a sort of "simple"
  // matrix to the Generator for determining what to show and when given selected
  // options
  const dropdown_filters = product_groups.filter(
    ({ item_selection: i }) => i === "single"
  );
  const checkbox_filters = product_groups.filter(
    ({ item_selection: i }) => i === "multiple"
  );

  const keyFilterMap = {
    dropdowns: dropdown_filters.map(({ key: k }) => k),
    checkboxes: checkbox_filters.map(({ key: k }) => k)
  };
  // Dropdowns info
  const product_id_list_by_dropdown = dropdown_filters.reduce((acc, next) => {
    const { key, products_in_group: products } = next;
    const element = containing_element.querySelector(
      `[data-filter-name=${key}]`
    );
    const element_id = element?.id || "";
    return {
      ...acc,
      [element_id]: products.map(({ id }) => id).sort()
    };
  }, {});
  // Checkboxes info
  const product_id_by_checkbox = checkbox_filters.reduce(
    (acc, { key, products_in_group: products }) => ({
      ...acc,
      ...products.reduce((p_acc, { id }) => {
        const element = containing_element.querySelector(
          `[data-filter-key="${key}-${id}"]`
        );
        const element_id = element?.id || "remove";

        return {
          ...p_acc,
          [element_id]: id
        };
      }, {})
    }),
    {}
  );

  delete product_id_by_checkbox.remove;

  //maps element to its product_filter name (for additional options maps by product id too)
  const logicMap = () => {
    const keys = product_groups.map(({ key }) => key);
    const productFilters = Object.keys(product_id_list_by_dropdown).concat(
      Object.keys(product_id_by_checkbox)
    );
    const obj = {};
    for (let i = 0; i < productFilters.length; i++) {
      const k = i < keys.length ? i : keys.length - 1;
      const o = { key: keys[k] };
      if (keys[k] === OPTIONS_FILTER) {
        const pid = product_id_by_checkbox[productFilters[i]];
        const productName = product_ids_map[pid].name;
        const productIds = Object.keys(relatedProductsMap[productName]);
        o.pids = productIds;
      } else {
        o.pids = product_id_list_by_dropdown[productFilters[i]];
      }
      obj[productFilters[i]] = o;
    }
    return obj;
  };

  //maps related options to product name to make options dynamic for dropdown on pdf
  const dropdownOptionsMap = () => {
    const obj = {};
    for (const k of Object.keys(product_id_list_by_dropdown).slice(1)) {
      const productSet = new Set(product_id_list_by_dropdown[k]);
      const relatedOptions = {};
      for (const rk of Object.keys(related_products_map)) {
        relatedOptions[rk] = related_products_map[rk]
          .filter((e) => productSet.has(e))
          .map((e) => [e, product_ids_map[e].name]);
      }
      obj[k] = relatedOptions;
    }
    return obj;
  };

  const productOptionIdMap = () => {
    const obj = {};
    product_groups.forEach((f) => {
      f.products_in_group.forEach(({ id }) => {
        obj[id] = f.key;
      });
    });
    return obj;
  };

  const relatedProductsMap = getRelatedProductsMap(
    dropdown_filters.find((e) => e.key === PRIMARY_FILTER)?.products_in_group
  );

  const obj = {
    product_names_sorted,
    //just product names sorted

    opt_products: product_id_by_checkbox,
    //option element mapped to product id
    //{module-config-tool-3_content_opts-0:98}

    opt_products_reverse: Object.entries(product_id_by_checkbox).reduce(
      (acc, [k, v]) => ({
        ...acc,
        [v]: k
      }),
      {}
    ),
    product_ids_map,
    //product id mapped to name, id, model, sku

    related_products_map: related_products_props_map(),
    //primary product mapped to related product mapped to limit, rules, dimension,impact
    // {
    //   92: {
    //     98: {
    //       impactDimensions: true,
    //       limit: 2,
    //       rulesObj: {
    //         meetAll: true,
    //         rules: []
    //       }
    //     }
    //   }
    // },

    logic_map: logicMap(),
    //field name mapped to object consisting of key and pids
    //module-...dropdown-0:{key:"printer-model", pids: [92,94]},
    //module-...opts-checkbox-0:{key:"additional-options", pids:[98]}

    dropdown_options_map: dropdownOptionsMap(),
    //dropdown field name mapped to product id mapped to array of options
    //module...dropdown-1:{c529r:[optionId,label]}

    settings: settings.map((s) => {
      if (!s.image) delete s.image;
      return s;
    }),
    product_option_id_map: productOptionIdMap(),
    //product id mapped to key
    //92: "printer-model"

    key_filter_map: keyFilterMap
    //dropdowns: ["printer-model","cabinet-stand-option"],
    //checkboxes: ["additional-options"]
  };
  return obj;
}

function loadConfigToolConfig(mod, configs) {
  const { page, containing_element } = configs;
  const { html_id } = mod;
  const { idx: page_idx } = page;
  const elements = getElements(mod, configs);
  const script_variables = getScriptVariables(mod, configs);
  return {
    config: {
      name: html_id,
      page: page_idx,
      position: getRelativeElementPosition(containing_element, configs.page),
      // Contain all content of a hotspot within the same element (and PDF layer)
      elements: elements
    },
    prefix: html_id,
    script_variables
  };
}
export { loadConfigToolConfig, scripts };
